import { ControlFacet } from '../models/controls/ControlFacet';
import { IDefaultDropActionHandler } from '../components/actions/defaultDrop/DefaultDropAction';

export const defaultDropActionControl = new ControlFacet<{
    itemKey: string;
}, {
        handlers: IDefaultDropActionHandler[];
    }>('defaultDropActionControl');
